'use strict';

import React from 'react';

import { OnSchedUtils } from "../../../../utils";
import FormCheckbox from "../../FormElement/FormCheckbox/FormCheckbox";


const AvailableDay = ({ day, element, data }) => {
  const [disabled, setDisabled] = React.useState(true);
  const [defaultChecked, setDefaultChecked] = React.useState(false);
  const [startTimeMeridiemAm, setStartTimeMeridiemAm] = React.useState(data.startTime < 1200);
  const [endTimeMeridiemAm, setEndTimeMeridiemAm] = React.useState(data.endTime < 1200);
  const [startTime, setStartTime] = React.useState(data.startTime);
  const [endTime, setEndTime] = React.useState(data.endTime);

  React.useEffect(() => {
    if (data) {
      if (data.startTime > 0 && data.endTime > 0) {
        if (!defaultChecked) {
          setDefaultChecked(true);
          setDisabled(false);
        }
        else {
          
        }
      }

      if (data.startTime >= 1200) {
        setStartTimeMeridiemAm(false);
      }
      
      if (data.endTime < 1200) {
        setEndTimeMeridiemAm(true);
      }
    }
  }, [data]);
  
  const selectClass = "onsched-border-border-color onsched-dark-color onsched-primary-border-color-hover onsched-primary-border-color-active onsched-primary-border-color-focus FormInput FormDropdown";
  const disabledClass = "onsched-border-border-color onsched-dark-color FormInput FormDropdown";

  const checkboxInput = {
    name: 'availability.' + day,
    label: document.getElementById(element.id)?.classList.contains('md') ? OnSchedUtils.Internationalize(element, `consumer_availability_weekday_${day}`) : OnSchedUtils.Internationalize(element, `consumer_availability_weekday_${day}`).slice(0,3),
    required: false,
    type: 'checkbox',
  }

  const disableRow = checked => {
    setDisabled(!checked);
  }

  const startTimeChange = time => {
    const selectedTime = parseInt(time);

    if (selectedTime > parseInt(endTime)) {
      setEndTime(selectedTime);
    }
    
    setStartTime(selectedTime);
  }

  const endTimeChange = time => {
    const selectedTime = parseInt(time);
    
    if (selectedTime < parseInt(startTime)) {
      setStartTime(selectedTime);
    }
    
    setEndTime(selectedTime);
  }

  const meridiemChange = e => {
    if (e.target.name.includes('endTimeMeridiem')) {
      setEndTimeMeridiemAm(e.target.value === "am" ? true : false);
      endTimeChange(e.target.value === "am" ? (endTime - 1200) : (endTime + 1200))
    }
    if (e.target.name.includes('startTimeMeridiem')) {
      setStartTimeMeridiemAm(e.target.value === "am" ? true : false);
      startTimeChange(e.target.value === "am" ? (startTime - 1200) : (startTime + 1200))
    }
  }

  return (
    <div className="AvailableDay">
      <FormCheckbox input={checkboxInput} defaultChecked={defaultChecked} callback={disableRow} />
      
      <div className={`time-of-day ${disabled ? 'disabled' : ''}`}>
        <div className="time-switch">
          <select name={`availability.${day}.startTime`} value={startTime} onChange={e => startTimeChange(e.target.value)} disabled={disabled} className={disabled ? disabledClass : selectClass}>
            <option value={startTimeMeridiemAm ? 0 : (1200 + 0)}>12:00</option>
            <option value={startTimeMeridiemAm ? 30 : (1200 + 30)}>12:30</option>
            <option value={startTimeMeridiemAm ? 100 : (1200 + 100)}>1:00</option>
            <option value={startTimeMeridiemAm ? 130 : (1200 + 130)}>1:30</option>
            <option value={startTimeMeridiemAm ? 200 : (1200 + 200)}>2:00</option>
            <option value={startTimeMeridiemAm ? 230 : (1200 + 230)}>2:30</option>
            <option value={startTimeMeridiemAm ? 300 : (1200 + 300)}>3:00</option>
            <option value={startTimeMeridiemAm ? 330 : (1200 + 330)}>3:30</option>
            <option value={startTimeMeridiemAm ? 400 : (1200 + 400)}>4:00</option>
            <option value={startTimeMeridiemAm ? 430 : (1200 + 430)}>4:30</option>
            <option value={startTimeMeridiemAm ? 500 : (1200 + 500)}>5:00</option>
            <option value={startTimeMeridiemAm ? 530 : (1200 + 530)}>5:30</option>
            <option value={startTimeMeridiemAm ? 600 : (1200 + 600)}>6:00</option>
            <option value={startTimeMeridiemAm ? 630 : (1200 + 630)}>6:30</option>
            <option value={startTimeMeridiemAm ? 700 : (1200 + 700)}>7:00</option>
            <option value={startTimeMeridiemAm ? 730 : (1200 + 730)}>7:30</option>
            <option value={startTimeMeridiemAm ? 800 : (1200 + 800)}>8:00</option>
            <option value={startTimeMeridiemAm ? 830 : (1200 + 830)}>8:30</option>
            <option value={startTimeMeridiemAm ? 900 : (1200 + 900)}>9:00</option>
            <option value={startTimeMeridiemAm ? 930 : (1200 + 930)}>9:30</option>
            <option value={startTimeMeridiemAm ? 1000 : (1200 + 1000)}>10:00</option>
            <option value={startTimeMeridiemAm ? 1030 : (1200 + 1030)}>10:30</option>
            <option value={startTimeMeridiemAm ? 1100 : (1200 + 1100)}>11:00</option>
            <option value={startTimeMeridiemAm ? 1130 : (1200 + 1130)}>11:30</option>
          </select>
          <select name={`availability.${day}.startTimeMeridiem`} onChange={meridiemChange} defaultValue={startTimeMeridiemAm ? "am" : "pm"} disabled={disabled} className={disabled ? disabledClass : selectClass}>
            <option value="am">am</option>
            <option value="pm">pm</option>
          </select>
        </div>
        
        <div className="time-switch">
          <select name={`availability.${day}.endTime`} value={endTime} onChange={e => endTimeChange(e.target.value)} disabled={disabled} className={disabled ? disabledClass : selectClass}>
            <option value={endTimeMeridiemAm ? 0 : (1200 + 0)}>12:00</option>
            <option value={endTimeMeridiemAm ? 30 : (1200 + 30)}>12:30</option>
            <option value={endTimeMeridiemAm ? 100 : (1200 + 100)}>1:00</option>
            <option value={endTimeMeridiemAm ? 130 : (1200 + 130)}>1:30</option>
            <option value={endTimeMeridiemAm ? 200 : (1200 + 200)}>2:00</option>
            <option value={endTimeMeridiemAm ? 230 : (1200 + 230)}>2:30</option>
            <option value={endTimeMeridiemAm ? 300 : (1200 + 300)}>3:00</option>
            <option value={endTimeMeridiemAm ? 330 : (1200 + 330)}>3:30</option>
            <option value={endTimeMeridiemAm ? 400 : (1200 + 400)}>4:00</option>
            <option value={endTimeMeridiemAm ? 430 : (1200 + 430)}>4:30</option>
            <option value={endTimeMeridiemAm ? 500 : (1200 + 500)}>5:00</option>
            <option value={endTimeMeridiemAm ? 530 : (1200 + 530)}>5:30</option>
            <option value={endTimeMeridiemAm ? 600 : (1200 + 600)}>6:00</option>
            <option value={endTimeMeridiemAm ? 630 : (1200 + 630)}>6:30</option>
            <option value={endTimeMeridiemAm ? 700 : (1200 + 700)}>7:00</option>
            <option value={endTimeMeridiemAm ? 730 : (1200 + 730)}>7:30</option>
            <option value={endTimeMeridiemAm ? 800 : (1200 + 800)}>8:00</option>
            <option value={endTimeMeridiemAm ? 830 : (1200 + 830)}>8:30</option>
            <option value={endTimeMeridiemAm ? 900 : (1200 + 900)}>9:00</option>
            <option value={endTimeMeridiemAm ? 930 : (1200 + 930)}>9:30</option>
            <option value={endTimeMeridiemAm ? 1000 : (1200 + 1000)}>10:00</option>
            <option value={endTimeMeridiemAm ? 1030 : (1200 + 1030)}>10:30</option>
            <option value={endTimeMeridiemAm ? 1100 : (1200 + 1100)}>11:00</option>
            <option value={endTimeMeridiemAm ? 1130 : (1200 + 1130)}>11:30</option>
          </select>
          <select name={`availability.${day}.endTimeMeridiem`} onChange={meridiemChange} defaultValue={endTimeMeridiemAm ? "am" : "pm"} disabled={disabled} className={disabled ? disabledClass : selectClass}>
            <option value="am">am</option>
            <option value="pm">pm</option>
          </select>
        </div>
      </div>
    </div>
  )
}

export default AvailableDay
